"use client";

import EmbedConsent from "rivals/components/shared/EmbedConsent";
import { TemplateName } from "rivals/shared/interfaces/Content";
import ApplePodcast from "./Embed/ApplePodcast";
import FacebookVideo from "./Embed/FacebookVideo";
import FloridaGatorsVideo from "./Embed/FloridaGatorsVideo";
import Instagram from "./Embed/Instagram";
import Libsyn from "./Embed/Libsyn";
import PodBean from "./Embed/PodBean";
import SendToNews from "./Embed/SendToNews";
import Sheets from "./Embed/Sheets";
import SoundCloud from "./Embed/SoundCloud";
import Spotify from "./Embed/Spotify";
import YahooSportsVideo from "./Embed/YahooSportsVideo";
import styles from "./TemplateBlock.module.scss";
import { Props } from "./types";

function Template({
  hasEmbedConsent,
  templateName,
  arguments: args
}: Props): JSX.Element | null {
  if (!hasEmbedConsent) {
    return <EmbedConsent />;
  }

  const templateArgs = JSON.parse(args);

  switch (templateName) {
    case TemplateName.ApplePodcast:
      return (
        <ApplePodcast
          accountId={templateArgs["account_id"]}
          podcastId={templateArgs["podcast_id"]}
        />
      );

    case TemplateName.FacebookVideo:
      return <FacebookVideo videoUrl={templateArgs["fb_video_url"]} />;
    case TemplateName.FloridaGatorsVideo:
      return <FloridaGatorsVideo archiveId={templateArgs["archive_id"]} />;
    case TemplateName.GoogleSheets:
      return (
        <Sheets
          gid={templateArgs["gid"]}
          height={templateArgs["height"]}
          sheetId={templateArgs["sheet_id"]}
        />
      );
    case TemplateName.Instagram:
      return <Instagram instagramId={templateArgs["instagram_id"]} />;
    case TemplateName.Libsyn:
      return <Libsyn podcastId={templateArgs["podcast_id"]} />;
    case TemplateName.PodBean:
      return <PodBean podcastId={templateArgs["podcast_id"]} />;
    case TemplateName.SendToNews:
      return <SendToNews videoId={templateArgs["video_id"]} />;
    case TemplateName.Soundcloud:
      return <SoundCloud trackId={templateArgs["track_id"]} />;
    case TemplateName.Spotify:
      return <Spotify episodeId={templateArgs["episode_id"]} />;
    case TemplateName.YahooSportsVideo:
      return <YahooSportsVideo videoUrl={templateArgs["ysports_video_url"]} />;
    default:
      return null;
  }
}

function TemplateBlock(props: Props): JSX.Element {
  return (
    <div className={styles.embedWrapper}>
      <Template {...props} />
    </div>
  );
}

export default TemplateBlock;
